<template>
  <v-app>
    <v-container fluid class="pa-2">
      <v-form @submit.prevent="submitForm">
        <v-row>

          <!-- INVOICE INFO -->
          <v-col cols="12">
            <v-expansion-panels v-model="panel" multiple>
              <v-expansion-panel>
                <v-expansion-panel-title class="panel-header" color="blue-grey-lighten-4">
                  Invoice Information
                </v-expansion-panel-title>

                <v-expansion-panel-text>
                  <v-row dense class="mt-3">

                    <v-col cols="12" md="3">
                      <v-text-field
                        label="Invoice No*"
                        v-model="invoice_no"
                        :error-messages="errors.invoice_no"
                        density="compact"
                        variant="outlined"
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field
                        label="Delta Room*"
                        v-model="delta_room"
                        :error-messages="errors.delta_room"
                        density="compact"
                        variant="outlined"
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="Invoice Date*"
                        v-model="invoice_date"
                        :error-messages="errors.invoice_date"
                        density="compact"
                        variant="outlined"
                        prepend-icon=""
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="Invoice Due Date"
                        v-model="invoice_due_date"
                        :error-messages="errors.invoice_due_date"
                        density="compact"
                        variant="outlined"
                        prepend-icon=""
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-text-field
                        label="Bill To*"
                        v-model="bill_to"
                        :error-messages="errors.bill_to"
                        density="compact"
                        variant="outlined"
                      />
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-text-field
                        label="Ship To*"
                        v-model="ship_to"
                        :error-messages="errors.ship_to"
                        density="compact"
                        variant="outlined"
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field label="Bank Name" v-model="bank_name" density="compact" variant="outlined"/>
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field label="Account No" v-model="bank_ac_no" density="compact" variant="outlined"/>
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field label="Account Name" v-model="bank_ac_name" density="compact" variant="outlined"/>
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field label="Branch Name" v-model="branch_name" density="compact" variant="outlined"/>
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field label="Routing No" v-model="routing_no" density="compact" variant="outlined"/>
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field label="Swift Code" v-model="swift_code" density="compact" variant="outlined"/>
                    </v-col>

                    <v-col cols="12" md="2">
                      <v-text-field type="number" label="Total*" v-model="total" :error-messages="errors.total" density="compact" readonly variant="outlined"/>
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-select
                        label="Currency*"
                        v-model="currency_id"
                        :items="currencyList"
                        :item-title="item => `${item.code} - ${item.name}`"
                        item-value="id"
                        :error-messages="errors.currency_id"
                        density="compact"
                        variant="outlined"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="2">
                      <v-text-field type="number" label="Paid*" v-model="paid" :error-messages="errors.paid" density="compact" variant="outlined"/>
                    </v-col>

                    <v-col cols="12" md="2">
                      <v-text-field type="number" label="Due*" v-model="due" :error-messages="errors.due" density="compact" variant="outlined"/>
                    </v-col>

                    <v-col cols="12" md="12">
                      <v-textarea
                        label="Additional Condition"
                        v-model="additional_condition"
                        :error-messages="errors.additional_condition"
                        rows="3"
                        density="compact"
                        variant="outlined"
                      />
                    </v-col>

                  </v-row>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>

          <!-- DETAILS TABLE -->
          <v-col cols="12">
            <v-expansion-panels v-model="panel1" multiple>
              <v-expansion-panel>
                <v-expansion-panel-title class="panel-header" color="blue-grey-lighten-4">
                  Invoice Details
                </v-expansion-panel-title>

                <v-expansion-panel-text>
                  <table class="custome-table mt-4">
                    <thead>
                      <tr>
                        <th class="table-header-cel" v-for="h in headers" :key="h.value">{{ h.text }}</th>
                        <th class="table-header-cel">Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr v-for="(row, rowIndex) in tableData" :key="row.id" :class="{ 'error-row': tableErrors[rowIndex] }">
                        <td v-for="(col, colIndex) in headers" :key="col.value" :class="{ 'error-td': (tableErrors[rowIndex]?.[col.value]) }">
                          <v-text-field
                            v-if="['item_description'].includes(col.value)"
                            class="breakdown-input"
                            v-model="row[col.value]"
                            type="text"
                            dense
                            hide-details
                            variant="outlined"
                            :readonly="col.value === 'total'"
                            :error-messages="tableErrors[rowIndex]?.[col.value]"
                            @keydown.enter.prevent="focusNextCell(rowIndex,colIndex)"
                          />
                          <v-text-field
                            v-if="['price','quantity'].includes(col.value)"
                            class="breakdown-input"
                            v-model="row[col.value]"
                            type="number"
                            dense
                            hide-details
                            variant="outlined"
                            :error-messages="tableErrors[rowIndex]?.[col.value]"
                            @update:model-value="calculateTotalValue(rowIndex)"
                            @keydown.enter.prevent="focusNextCell(rowIndex,colIndex)"
                          />

                          <v-text-field
                            v-if="['total'].includes(col.value)"
                            class="breakdown-input"
                            v-model="row[col.value]"
                            type="number"
                            dense
                            hide-details
                            readonly=""
                            variant="outlined"
                            :error-messages="tableErrors[rowIndex]?.[col.value]"
                            @keydown.enter.prevent="focusNextCell(rowIndex,colIndex)"
                          />

                          <v-autocomplete
                            style="height: 32px !important; min-width:100px;"
                            v-if="['currency_id'].includes(col.value)"
                            class="breakdown-input"
                            v-model="row[col.value]"
                            :items="currencyList"
                            :item-title="item => `${item.code} - ${item.name}`"
                            item-value="id"
                            density="compact"
                            variant="outlined"
                          />
                        </td>
                        <td style="width:65px;">
                          <v-btn v-if=" (rowIndex != tableData.length - 1) || (tableData.length > 1)" icon variant="tonal" size="small" color="primary" class="pa-1 breakdown-input" @click="removeRow(rowIndex)">
                              <v-icon color="red">mdi-close</v-icon>
                          </v-btn>

                          <v-btn v-if="rowIndex == tableData.length - 1" variant="tonal" icon size="small" color="primary" class=" breakdown-input" @click="addRow">
                              <v-icon color="blue">mdi-plus</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                    <v-card-actions class="justify-end">
                      <v-btn class="bg-grey-darken-1 me-2" @click="submitForm(0)">Draft</v-btn>
                      <v-btn class="bg-primary" @click="submitForm(1)">
                        {{ isEdit ? 'Update' : 'Save' }}
                      </v-btn>
                    </v-card-actions>

                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>

        </v-row>
      </v-form>
    </v-container>
  </v-app>
</template>

<script setup>
import { ref, reactive, onMounted, nextTick } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import * as yup from "yup";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";

const store = useStore();
const route = useRoute();
const router = useRouter();
const updateId = route.params.id;

const panel = ref([0]);
const panel1 = ref([0]);
const isEdit = ref(false);

const invoice_no = ref("");
const delta_room = ref("");
const invoice_date = ref(null);
const invoice_due_date = ref(null);
const bill_to = ref("");
const ship_to = ref("");
const bank_name = ref("");
const bank_ac_no = ref("");
const bank_ac_name = ref("");
const branch_name = ref("");
const routing_no = ref("");
const additional_condition = ref("");
const swift_code = ref("");
const currency_id = ref(null);
const total = ref(0);
const paid = ref(0);
const due = ref(0);
const currencyList = ref([]);

const headers = [
  { text: "Item Description", value: "item_description" },
  { text: "Price", value: "price" },
  { text: "Quantity", value: "quantity" },
  { text: "Total", value: "total" },
  { text: "Currency", value: "currency_id" },
];

const tableData = reactive([]);
const errors = reactive({});
const tableErrors = reactive({});

async function getInitialData(){
  
      store.commit("SET_LOADING", { color: "primary" });
      const invoiceBill = updateId ? await store.dispatch("getInvoiceBillById", { id: updateId }) : null;
      const currencyListRes = await store.dispatch("getCurrencyList");
      currencyList.value = currencyListRes.data.currency;
      store.commit("UNSET_LOADING");

      if(updateId){
        isEdit.value = true;

        const data = invoiceBill.data.data;

        invoice_no.value = data.invoice_no;
        delta_room.value = data.delta_room;
        invoice_date.value = data.invoice_date;
        invoice_due_date.value = data.invoice_due_date;
        bill_to.value = data.bill_to;
        ship_to.value = data.ship_to;
        bank_name.value = data.bank_name;
        bank_ac_no.value = data.bank_ac_no;
        bank_ac_name.value = data.bank_ac_name;
        branch_name.value = data.branch_name;
        routing_no.value = data.routing_no;
        additional_condition.value = data.additional_condition;
        swift_code.value = data.swift_code;
        currency_id.value = data.currency_id;
        total.value = data.total;
        paid.value = data.paid;
        due.value = data.due;

        tableData.splice(0); 
        data.details.forEach((d, index) => {
            tableData.push({
              id: index + 1,
              item_description: d.item_description,
              price: d.price,
              quantity: d.quantity,
              total: d.total,
              currency_id: d.currency_id,
            });
        });
      }
      if (!tableData.length) addRow();
}

function addRow() {
  tableData.push({ id: Date.now(), item_description:"", price:0, quantity:0, total:0, currency_id: null });
}

function removeRow(i){ if(tableData.length>1) tableData.splice(i,1); }

function calculateTotalValue(i){
  tableData[i].total = tableData[i].price * tableData[i].quantity;
  var grandTotal = 0;
  for (let i = 0; i < tableData.length; i++) {
    grandTotal += tableData[i]?.total ?? 0;
  }
  total.value = grandTotal;
}

const detailsSchema = yup.object({
  item_description: yup.string().required("Color required"),
  price: yup.number().typeError("Unit price must be number").required().min(0),
  quantity: yup.number().typeError("Quantity must be number").required().positive(),
  total: yup.number().typeError("Total amount must be number").required(),
});

const schema = yup.object({
  invoice_no:yup.string().required(),
  delta_room:yup.string().required(),
  invoice_date:yup.date().required(),
  bill_to:yup.string().required(),
  ship_to:yup.string().required(),
  total:yup.number().required(),
  paid:yup.number().required(),
  due:yup.number().required(),
  details: yup.array().of(detailsSchema).min(1),
});

async function submitForm(status){
  Object.keys(errors).forEach(k=>delete errors[k]);
  Object.keys(tableErrors).forEach(k => delete tableErrors[k]);

  const payload = {
    invoice_no:invoice_no.value,
    delta_room:delta_room.value,
    invoice_date:formattedDate(invoice_date.value),
    invoice_due_date:formattedDate(invoice_due_date.value),
    bill_to:bill_to.value,
    ship_to:ship_to.value,
    bank_name:bank_name.value,
    bank_ac_no:bank_ac_no.value,
    bank_ac_name:bank_ac_name.value,
    branch_name:branch_name.value,
    routing_no:routing_no.value,
    additional_condition:additional_condition.value,
    swift_code:swift_code.value,
    currency_id:currency_id.value,
    total:total.value,
    paid:paid.value,
    due:due.value,
    status,
    details:tableData,
  };

  try{
    await schema.validate(payload,{abortEarly:false});
    if(isEdit.value){
      await store.dispatch("updateInvoiceBill",{id:updateId,data:payload}).then((res) => {
        if(!res.data.success){
            toast.error(res.data.message);
        }else{
            toast.success("Saved Successfully");
            router.push({ name: "invoice-bill-record" });
        }
      });
    }else{
      await store.dispatch("saveInvoiceBill",payload).then((res) => {
        if(!res.data.success){
            toast.error(res.data.message);
        }else{
            toast.success("Saved Successfully");
            router.push({ name: "invoice-bill-record" });
        }
      });
    }
  }catch(e){
    e.inner.forEach(e => {
      if (e.path && e.path.startsWith("details")) {
          const match = e.path.match(/details\[(\d+)\]\.(.+)/);
          if (match) {
              const rowIndex = match[1];
              const field = match[2];

              if (!tableErrors[rowIndex]) tableErrors[rowIndex] = {};
              tableErrors[rowIndex][field] = e.message;
          }
      } else {
          errors[e.path] = e.message;
      }
    });
  }
}

  onMounted(getInitialData);
</script>

<style>
.panel-header {
  background: #eceff1;
  font-weight: 600;
}

.breakdown-input .v-field {
  min-height: 32px !important;
  height: 32px !important;
  border:none !important;
  border-radius: 0px !important;
}

.breakdown-input .v-field .v-field__input {
  min-height: 32px !important; 
  height: 32px !important;
  padding: 2 !important;
  font-size: 12px;
}

.breakdown-input input{
    min-height: 32px !important; 
  height: 32px !important;
  max-height: 32px !important;
}


.custome-table {
    width: 100% !important;
    border-collapse: collapse;
}

.custome-table th,
.custome-table td {
    border: 1px solid #c0c0c0;
    text-align: left; 
}

.custome-table th {
    background-color: #eceff1; 
    font-weight: 600;
}
.table-header-cel{
    text-align: center !important;
    height: 30px;
    font-size: 12px;
}

.v-btn--icon{
  height: 30px !important;
  width: 30px !important;
}
.error-row {
  /* background: #fff3f3; */
}
.error-td{
  border-color: red !important;
}

</style>

